export default __webpack_public_path__ + "static/media/arrow-down.edf5c3f9.svg";